import { IS_PROD } from './Components/Constants';

const RAJ_CALENDLY = "https://calendly.com/logisticsnow/logisticsnow-connect"
// const SALES_LORRI_AI_CALENDLY = 'https://calendly.com/lorri-sales/30min'
const SHARVIL_CALENDLY = 'https://calendly.com/sharvil-thelogisticsnow/30min';


export const CALENDLY_URL = IS_PROD ? RAJ_CALENDLY : SHARVIL_CALENDLY;
